<template>
    <div>
        <company-form></company-form>
    </div>
</template>

<script>
import CompanyForm from '@/components/pages/companies/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: { CompanyForm },
    mixins: [dirtyForm],
}
</script>
